import React from "react"
import {CmCollection, CmTeasable, SosTeaser} from "../../../../packages/graphql-layer/src";
import C014StageTeaser from "../C014StageCarousel/C014StageTeaser";
import {Box} from "@mui/system";
import {Grid} from "@mui/material";
import TeaserCard from "../C020TeaserCarousel/TeaserCard";
import CCOContainer from "../../fundamentals/CCOContainer";
import useWindowSize from "../../../utility/useWindowSize";
import C020TeaserCarousel from "../C020TeaserCarousel/C020TeaserCarousel";


export interface Props {
    cmCollection: CmCollection
}

function C075Hero(props: Props) {

    const { lowerThanWindowSmall } = useWindowSize();
    const items = props.cmCollection.items || [];
    const stageItem = items[0] as CmTeasable;
    const teaserItems = items.slice(1);

    const renderGridTeasers = () => {
        if (items.length === 2) {
            return (
                <Grid item md={12} sm={12} display="flex" alignItems="stretch" padding={3}>
                    <TeaserCard item={items[1]} horizontal hero />
                </Grid>
            );
        }

        const sliceEnd = items.length === 3 ? 3 : 4;
        const columnSize = items.length === 3 ? 6 : 4;

        return (
            <Grid container justifyContent="center">
                {teaserItems.slice(0, sliceEnd - 1).map((item, index) => (
                    <Grid
                        item
                        key={index}
                        md={columnSize}
                        sm={12}
                        display="flex"
                        alignItems="stretch"
                        padding={3}
                    >
                        <TeaserCard item={item} hero />
                    </Grid>
                ))}
            </Grid>
        );
    };


    return (
        <>
            <C014StageTeaser dataCypress="heroStageTeaser" item={stageItem} hero />
            <CCOContainer width="full" background={"grey"}>
                <Box
                    sx={{
                        position: 'relative',
                        top: { xl: '-164px', md: '-64px', sm: '0' },
                        mb: { xl: '-150px', md: '-60px', sm: '0' },
                    }}
                >
                    {lowerThanWindowSmall ? (
                        <C020TeaserCarousel
                            cmCollection={{ ...props.cmCollection, items: teaserItems }}
                            background={"grey"}
                            isHeroCarousel={lowerThanWindowSmall}
                        />
                    ) : (
                        renderGridTeasers()
                    )}
                </Box>
            </CCOContainer>
        </>
    );
}

export default C075Hero